import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { Collapse } from 'reactstrap';
import { Link } from 'react-router-dom';
import withRouter from 'components/Common/withRouter';
import classname from 'classnames';

import { withTranslation, useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

const SaaSNavbar = (props) => {
  // State for dropdowns
  const [tenantsOpen, setTenantsOpen] = useState(false);
  const [rolesOpen, setRolesOpen] = useState(false);
  const [ticketsOpen, setTicketsOpen] = useState(false);
  const [authOpen, setAuthOpen] = useState(false);

  const { i18n, t } = useTranslation();
  const isUrdu = i18n.language === 'ur';

  useEffect(() => {
    var matchingMenuItem = null;
    var ul = document.getElementById('navigation');
    var items = ul.getElementsByTagName('a');
    removeActivation(items);
    for (var i = 0; i < items.length; ++i) {
      if (window.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  });

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;
      if (item && item.classList.contains('active')) {
        item.classList.remove('active');
      }
      if (parent && parent.classList.contains('active')) {
        parent.classList.remove('active');
      }
    }
  };

  function activateParentDropdown(item) {
    item.classList.add('active');
    const parent = item.parentElement;
    if (parent) {
      parent.classList.add('active');
      const parent2 = parent.parentElement;
      parent2?.classList.add('active');
      const parent3 = parent2?.parentElement;
      parent3?.classList.add('active');
      const parent4 = parent3?.parentElement;
      parent4?.classList.add('active');
    }
    return false;
  }

  return (
    <React.Fragment>
      <div className="topnav">
        <div className="container-fluid">
          <nav className="navbar navbar-light navbar-expand-lg topnav-menu" id="navigation">
            <Collapse isOpen={props.leftMenu} className="navbar-collapse" id="topnav-menu-content">
              <ul className={`navbar-nav ${isUrdu ? 'text-end fw-bold' : ''}`}>
                <li className="nav-item">
                  <Link to="/dashboard" className="nav-link">
                    <span>{t('Dashboard')}</span>
                  </Link>
                </li>

                <li className="nav-item dropdown">
                  <Link
                    to="#"
                    className="nav-link dropdown-toggle arrow-none"
                    onClick={(e) => {
                      e.preventDefault();
                      setTenantsOpen(!tenantsOpen);
                    }}
                  >
                    <span>{t('Tenants')}</span>
                  </Link>
                  <div className={classname('dropdown-menu', { show: tenantsOpen })}>
                    <Link to="/tenants/list" className="dropdown-item">
                      {t('Tenant List')}
                    </Link>
                    <Link to="/tenants/requests" className="dropdown-item">
                      {t('Tenant Requests')}
                    </Link>
                  </div>
                </li>

                <li className="nav-item">
                  <Link to="/users" className="nav-link">
                    <span>{t('Users')}</span>
                  </Link>
                </li>

                <li className="nav-item dropdown">
                  <Link
                    to="#"
                    className="nav-link dropdown-toggle arrow-none"
                    onClick={(e) => {
                      e.preventDefault();
                      setRolesOpen(!rolesOpen);
                    }}
                  >
                    <span>{t('Roles & Permissions')}</span>
                  </Link>
                  <div className={classname('dropdown-menu', { show: rolesOpen })}>
                    <Link to="/roles/list" className="dropdown-item">
                      {t('Roles')}
                    </Link>
                    <Link to="/permissions/list" className="dropdown-item">
                      {t('Permissions')}
                    </Link>
                  </div>
                </li>

                <li className="nav-item">
                  <Link to="/pricing-plans" className="nav-link">
                    <span>{t('Pricing Plans')}</span>
                  </Link>
                </li>

                <li className="nav-item">
                  <Link to="/subscriptions" className="nav-link">
                    <span>{t('Subscriptions')}</span>
                  </Link>
                </li>

                <li className="nav-item">
                  <Link to="/promotions" className="nav-link">
                    <span>{t('Promotions')}</span>
                  </Link>
                </li>

                <li className="nav-item dropdown">
                  <Link
                    to="#"
                    className="nav-link dropdown-toggle arrow-none"
                    onClick={(e) => {
                      e.preventDefault();
                      setTicketsOpen(!ticketsOpen);
                    }}
                  >
                    <span>{t('Support Tickets')}</span>
                  </Link>
                  <div className={classname('dropdown-menu', { show: ticketsOpen })}>
                    <Link to="/tickets/list" className="dropdown-item">
                      {t('Ticket List')}
                    </Link>
                    <Link to="/tickets/history" className="dropdown-item">
                      {t('Ticket History')}
                    </Link>
                  </div>
                </li>

                <li className="nav-item">
                  <Link to="/notifications" className="nav-link">
                    <span>{t('Notifications')}</span>
                  </Link>
                </li>

                <li className="nav-item">
                  <Link to="/audit-logs" className="nav-link">
                    <span>{t('Audit Logs')}</span>
                  </Link>
                </li>

                <li className="nav-item">
                  <Link to="/otp-verifications" className="nav-link">
                    <span>{t('OTP Verifications')}</span>
                  </Link>
                </li>

                <li className="nav-item dropdown">
                  <Link
                    to="#"
                    className="nav-link dropdown-toggle arrow-none"
                    onClick={(e) => {
                      e.preventDefault();
                      setAuthOpen(!authOpen);
                    }}
                  >
                    <span>{t('Authentication')}</span>
                  </Link>
                  <div className={classname('dropdown-menu', { show: authOpen })}>
                    <Link to="/auth/login" className="dropdown-item">
                      {t('Login')}
                    </Link>
                    <Link to="/auth/refresh-tokens" className="dropdown-item">
                      {t('Refresh Tokens')}
                    </Link>
                  </div>
                </li>

                {/* Settings Title */}
                <li className="nav-item menu-title">{t('Settings')}</li>

                <li className="nav-item">
                  <Link to="/settings" className="nav-link">
                    <span>{t('Settings')}</span>
                  </Link>
                </li>
              </ul>
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  );
};

SaaSNavbar.propTypes = {
  leftMenu: PropTypes.any,
  t: PropTypes.any,
};

const mapStatetoProps = (state) => {
  return {};
};

export default connect(mapStatetoProps, {})(withRouter(withTranslation()(SaaSNavbar)));
